/**
 * age-fadein.js
 */

document.addEventListener('DOMContentLoaded', function() {
  // fadeinクラスが付与されたすべての要素を取得
  var fadeinElements = document.querySelectorAll('.js-fadein');

  // 画面内に表示されたらactiveクラスを追加する関数
  function addActiveClassIfVisible() {
    fadeinElements.forEach(function(element) {
      var rect = element.getBoundingClientRect();
      var isVisible = rect.top <= window.innerHeight && rect.bottom >= 0;
      if (isVisible) {
        element.classList.add('is-fadein');
      }
    });
  }

  // ページがロードされたときに初回チェック
  addActiveClassIfVisible();

  // スクロール時のチェック
  window.addEventListener('scroll', function() {
    addActiveClassIfVisible();
  });
});